import React, { ReactElement, useEffect } from 'react';
import { IAnswer,IQuestion ,IQuizQuestionResult} from '../model/Interfaces';
import QuizAnswer from './QuizAnswer';

export interface IQuizQuestionProps{
    Question: IQuestion,
    QuestionNumber: number,
    CssClass?: string,
    mode:number,
    onAnswered(QuestionNumber:number, Result:IQuizQuestionResult): void,
    onContinue(): void
}

function QuizQuestion(props:IQuizQuestionProps):React.ReactElement{
    const [ClueUsed,setClueUsed] = React.useState(false);
    const [Answered,setAnswered] = React.useState({} as IAnswer);
    const [showClue,setShowClue] = React.useState('none');

    const timer = React.useRef({} as NodeJS.Timeout);

    const raiseAnswered = (Answer:IAnswer):void=>{
        const result = {
            value:Answer.value,
            usedClue:ClueUsed
        }

        props.onAnswered(props.QuestionNumber,result);
    }

    const showRightWrong = (Answer:IAnswer):void=>{
        setAnswered(Answer);
        raiseAnswered(Answer);
    }

    const onNext = () => {
        clearTimeout(timer.current);
        props.onContinue();
    }

    const onClueSelected = ():void =>{
        setShowClue(showClue==='none' ? 'flex' : 'none');
        setClueUsed(true);
    }

    const onClearClue = ():void=>{
        setShowClue('none');
    }

    const onKeyUp = () => (e:React.KeyboardEvent<HTMLDivElement>) =>{
        console.log(e.key);
        
        props.Question.answers.forEach((a)=>{
            if (a.key == e.key){
                showRightWrong(a);
            }
        })

        
    }
    useEffect( () =>{
        if (Answered.correct && props.mode == 0){
            timer.current = setTimeout(onNext,2100);
        }
    });

    useEffect( ()=>{
        setClueUsed(false);
        setAnswered({} as IAnswer);
        clearTimeout(timer.current);

    },[props.QuestionNumber]);

    useEffect(() => {
        document.addEventListener("keyup", onKeyUp);
        return () => {
          document.removeEventListener("keyup", onKeyUp);
        };
      }, [onKeyUp]);

    let answers:ReactElement[] = [];

    if (Answered.key != null){
        if (props.Question.answers!= null){
            answers = props.Question.answers.map((answer)=>{
                return <p key={answer.key} className={answer.correct ? 'answer-correct' : (answer.key===Answered.key ? 'answer-wrong' : '')}>
                        {answer.key}) {answer.answer}</p>;
            })
        }
        if (!Answered.correct || props.mode !=0){
            answers.push(<button className='next' key='btnNext' onClick={onNext}>Next</button>);
        }
    } else {
        if (props.Question.answers!= null){
            answers = props.Question.answers.map((answer)=>{
                return <QuizAnswer key={answer.key} Answer ={answer}  onSelect={showRightWrong} />;
            })
        } else {
            answers = [<button className='next' key='btnNext' onClick={onNext}>Next</button>]
        }
    }


    return (
        <div className='question-section'>
            <p className='question-text'>{props.Question.question}</p>
            {props.mode ==0 && <div className='clue-section'>
                <button type='button' 
                    onClick={onClueSelected} 
                    className='clue-button'>?</button>
                <div className='clue-text' 
                    style={{display:showClue}}
                    onClick={onClearClue}>
                    <p dangerouslySetInnerHTML={{__html:props.Question.clue}}></p>
                </div>
            </div>}
            <div className='answer-section'>
                {answers}
            </div>
        </div>
    )

    
}

export default QuizQuestion;